import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

const Privacy: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 min-h-[calc(100vh-200px)]">
      {/* Meta */}
      <div className="flex items-start justify-between mb-4">
        <h1 className="text-3xl font-bold">{t('privacy.title')}</h1>
        <div className="text-right">
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded mr-2">{t('privacy.lastUpdated')}</span>
          <span className="inline-block bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded">{t('privacy.version')}</span>
        </div>
      </div>

      {/* Intro */}
      <p className="text-gray-700 mb-6">
        {t('privacy.intro')}
      </p>

      {/* Key Points */}
      <div className="border border-gray-200 rounded-lg p-4 mb-6">
        <h2 className="text-sm font-semibold text-gray-900 mb-2">{t('privacy.keyPoints.title')}</h2>
        <ul className="list-disc pl-6 text-sm text-gray-700 space-y-1">
          <li>{t('privacy.keyPoints.item1')}</li>
          <li>{t('privacy.keyPoints.item2')}</li>
          <li>{t('privacy.keyPoints.item3')}</li>
          <li>{t('privacy.keyPoints.item4')}</li>
          <li>{t('privacy.keyPoints.item6')}</li>
          <li>{t('privacy.keyPoints.item7')}</li>
          <li>{t('privacy.keyPoints.item8')}</li>
          <li>{t('privacy.keyPoints.item8a')}</li>
          <li>{t('privacy.keyPoints.item9')}</li>
          <li>{t('privacy.keyPoints.item10')}</li>
          <li>{t('privacy.keyPoints.item11')}</li>
          <li>{t('privacy.keyPoints.item12')}</li>
          <li>{t('privacy.keyPoints.item13')}</li>
          <li>{t('privacy.keyPoints.item14')}</li>
          <li>{t('privacy.keyPoints.item15')}</li>
          <li>{t('privacy.keyPoints.item16')}</li>
          <li>{t('privacy.keyPoints.item17')}</li>
          <li>{t('privacy.keyPoints.item18')}</li>
          <li>{t('privacy.keyPoints.item19')}</li>
          <li>{t('privacy.keyPoints.item20')}</li>
          <li>{t('privacy.keyPoints.item21')}</li>
          <li>{t('privacy.keyPoints.item22')}</li>
          <li>{t('privacy.keyPoints.item23')}</li>
          <li>{t('privacy.keyPoints.item24')}</li>
          <li>{t('privacy.keyPoints.item25')}</li>
          <li>{t('privacy.keyPoints.item26')}</li>
          <li>{t('privacy.keyPoints.item27')}</li>
          <li>{t('privacy.keyPoints.item28')}</li>
          <li>{t('privacy.keyPoints.item29')}</li>
          <li>{t('privacy.keyPoints.item30')}</li>
          <li>{t('privacy.keyPoints.item31')}</li>
          <li>{t('privacy.keyPoints.item32')}</li>
          <li>{t('privacy.keyPoints.item33')}</li>
          <li>{t('privacy.keyPoints.item34')}</li>
          <li>{t('privacy.keyPoints.item36')}</li>
          <li>{t('privacy.keyPoints.item37')}</li>
        </ul>
      </div>

      {/* Table of Contents */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-8">
        <h2 className="text-sm font-semibold text-gray-900 mb-2">{t('privacy.toc.title')}</h2>
        <ol className="list-decimal pl-5 text-sm text-gray-800 space-y-1">
          <li><a className="hover:underline" href="#sec1">{t('privacy.toc.sec1')}</a></li>
          <li><a className="hover:underline" href="#sec2">{t('privacy.toc.sec2')}</a></li>
          <li><a className="hover:underline" href="#sec3">{t('privacy.toc.sec3')}</a></li>
          <li><a className="hover:underline" href="#sec4">{t('privacy.toc.sec4')}</a></li>
          <li><a className="hover:underline" href="#sec5">{t('privacy.toc.sec5')}</a></li>
          <li><a className="hover:underline" href="#sec6">{t('privacy.toc.sec6')}</a></li>
          <li><a className="hover:underline" href="#sec7">{t('privacy.toc.sec7')}</a></li>
          <li><a className="hover:underline" href="#sec8">{t('privacy.toc.sec8')}</a></li>
          <li><a className="hover:underline" href="#sec9">{t('privacy.toc.sec9')}</a></li>
          <li><a className="hover:underline" href="#sec10">{t('privacy.toc.sec10')}</a></li>
          <li><a className="hover:underline" href="#sec11">{t('privacy.toc.sec11')}</a></li>
          <li><a className="hover:underline" href="#sec12">{t('privacy.toc.sec12')}</a></li>
          <li><a className="hover:underline" href="#sec13">{t('privacy.toc.sec13')}</a></li>
        </ol>
      </div>

      <h2 id="sec1" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec1.title')}</h2>
      <ul className="list-disc pl-6 text-gray-700 space-y-2">
        <li>{t('privacy.sec1.item1')}</li>
        <li>{t('privacy.sec1.item2')}</li>
        <li>{t('privacy.sec1.item3')}</li>
        <li>{t('privacy.sec1.item6')}</li>
        <li>{t('privacy.sec1.item7')}</li>
        <li>{t('privacy.sec1.item8WithPayments')}</li>
        <li>{t('privacy.sec1.item8a')}</li>
        <li>{t('privacy.sec1.item9')}</li>
        <li>{t('privacy.sec1.item11')}</li>
        <li>{t('privacy.sec1.item12')}</li>
        <li>{t('privacy.sec1.item13')}</li>
        <li>{t('privacy.sec1.item14')}</li>
        <li>{t('privacy.sec1.item15')}</li>
        <li>{t('privacy.sec1.item16')}</li>
        <li>{t('privacy.sec1.item17')}</li>
        <li>{t('privacy.sec1.item18')}</li>
        <li>{t('privacy.sec1.item19')}</li>
        <li>{t('privacy.sec1.item20')}</li>
        <li>{t('privacy.sec1.item21')}</li>
        <li>{t('privacy.sec1.item22')}</li>
        <li>{t('privacy.sec1.item23')}</li>
        <li>{t('privacy.sec1.item24')}</li>
        <li>{t('privacy.sec1.item25')}</li>
        <li>{t('privacy.sec1.item26')}</li>
        <li>{t('privacy.sec1.item27')}</li>
        <li>{t('privacy.sec1.item28')}</li>
        <li>{t('privacy.sec1.item29')}</li>
        <li>{t('privacy.sec1.item30')}</li>
      </ul>

      <h2 id="sec2" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec2.title')}</h2>
      <ul className="list-disc pl-6 text-gray-700 space-y-2">
        <li>{t('privacy.sec2.item1')}</li>
        <li>{t('privacy.sec2.item2')}</li>
        <li>{t('privacy.sec2.item3')}</li>
        <li>{t('privacy.sec2.item4')}</li>
        <li>{t('privacy.sec2.item5')}</li>
        <li>{t('privacy.sec2.item6')}</li>
        <li>{t('privacy.sec2.item7')}</li>
      </ul>

      <h2 id="sec3" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec3.title')}</h2>
      <ul className="list-disc pl-6 text-gray-700 space-y-2">
        <li>{t('privacy.sec3.item1')}</li>
        <li>{t('privacy.sec3.item2')}</li>
        <li>{t('privacy.sec3.item3')}</li>
        <li>{t('privacy.sec3.item4')}</li>
        <li>{t('privacy.sec3.item5')}</li>
        <li>{t('privacy.sec3.item6')}</li>
        <li>{t('privacy.sec3.item7')}</li>
      </ul>

      <h2 id="sec4" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec4.title')}</h2>
      <p className="text-gray-700">
        <Trans i18nKey="privacy.sec4.text" ns="legal">
          You have the right to access... <span className="underline">legal@cevee.eu</span>.
        </Trans>
      </p>
      <p className="text-gray-700 mt-4 italic">{t('privacy.sec4.consentWithdrawal')}</p>
      <p className="text-gray-700 mt-4 italic">{t('privacy.sec4.dataPortability')}</p>
      <p className="text-gray-700 mt-4 italic">{t('privacy.sec4.accountDeletion')}</p>

      <h2 id="sec5" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec5.title')}</h2>
      <p className="text-gray-700 mb-3">{t('privacy.sec5.text')}</p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec5.consent')}</strong></p>
      <p className="text-gray-700 mb-3">{t('privacy.sec5.process')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec5.withdrawal')}</p>
      <p className="text-gray-700 italic">{t('privacy.sec5.legalBasis')}</p>
      <p className="text-gray-700 mt-4 italic border-l-4 border-gray-300 pl-4">{t('privacy.sec5.platformScreenshots')}</p>

      <h2 id="sec6" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec6.title')}</h2>
      <p className="text-gray-700 mb-3">{t('privacy.sec6.text')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec6.measures')}</p>
      <p className="text-gray-700 italic">{t('privacy.sec6.contact')}</p>

      <h2 id="sec7" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec7.title')}</h2>
      <p className="text-gray-700 mb-3">{t('privacy.sec7.intro')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec7.creatorData')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec7.legalBasis')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec7.search')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec7.contactForm')}</p>
      <p className="text-gray-700">{t('privacy.sec7.marketing')}</p>

      <h2 id="sec8" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec8.title')}</h2>
      <p className="text-gray-700 mb-3">{t('privacy.sec8.intro')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec8.anonymity')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec8.dataProcessed')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec8.aiModeration')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec8.reporting')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec8.personalization')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec8.retention')}</p>
      <p className="text-gray-700 italic">{t('privacy.sec8.legalBasis')}</p>

      <h2 id="sec9" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec9.title')}</h2>
      <p className="text-gray-700">
        <Trans i18nKey="privacy.sec9.text" ns="legal">
          Responsible: Cevee UG... <span className="underline">legal@cevee.eu</span>. Competent...
        </Trans>
      </p>

      <h2 id="sec10" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec10.title')}</h2>
      <p className="text-gray-700 mb-3">{t('privacy.sec10.intro')}</p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec10.consent')}</strong></p>
      <p className="text-gray-700 mb-3">{t('privacy.sec10.dataCategories')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec10.aiProvider')}</p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec10.humanInTheLoop')}</strong></p>
      <p className="text-gray-700 mb-3">{t('privacy.sec10.controller')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec10.retention')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec10.safety')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec10.euAiAct')}</p>
      <p className="text-gray-700 italic">{t('privacy.sec10.legalBasis')}</p>

      <h2 id="sec11" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec11.title')}</h2>
      <p className="text-gray-700 mb-3">{t('privacy.sec11.intro')}</p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec11.controller')}</strong></p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec11.consent')}</strong></p>
      <p className="text-gray-700 mb-3">{t('privacy.sec11.dataCategories')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec11.access')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec11.aiProvider')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec11.retention')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec11.humanInTheLoop')}</p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec11.prescreen')}</strong></p>
      <p className="text-gray-700 italic">{t('privacy.sec11.legalBasis')}</p>

      <h2 id="sec12" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec12.title')}</h2>
      <p className="text-gray-700 mb-3">{t('privacy.sec12.intro')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec12.dataCategories')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec12.sources')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec12.employerRemoval')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec12.aiProvider')}</p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec12.autoMatch')}</strong></p>
      <p className="text-gray-700 mb-3">{t('privacy.sec12.aggregateStats')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec12.interested')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec12.retention')}</p>
      <p className="text-gray-700 italic">{t('privacy.sec12.legalBasis')}</p>

      <h2 id="sec13" className="text-xl font-semibold mt-8 mb-2">{t('privacy.sec13.title')}</h2>
      <p className="text-gray-700 mb-3">{t('privacy.sec13.intro')}</p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec13.controller')}</strong></p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec13.consent')}</strong></p>
      <p className="text-gray-700 mb-3">{t('privacy.sec13.dataCategories')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec13.aiProvider')}</p>
      <p className="text-gray-700 mb-3"><strong>{t('privacy.sec13.humanInTheLoop')}</strong></p>
      <p className="text-gray-700 mb-3">{t('privacy.sec13.autoAdvance')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec13.warmIntro')}</p>
      <p className="text-gray-700 mb-3">{t('privacy.sec13.retention')}</p>
      <p className="text-gray-700 italic">{t('privacy.sec13.legalBasis')}</p>

      <p className="text-gray-600 mt-8">{t('privacy.footer')}</p>
    </div>
  );
};

export default Privacy;
